<script>
export default {
  template: '<template></template>',
}
</script>

<style lang="scss">
@use './TermsAndConditions';
</style>
